export { default } from './SectionSeoInfo';